import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUser } from '@fs/zion-user'
import { NoticeLoading } from '@fs/zion-icon'
import { signSessionContract } from '../../../api/rootstech/contracts'
import { useErrorHandlerOverlay, useLazyRequest } from '../../../hooks'
import { PillButton } from '../../../lib/buttons'

export default function AgreementButton({ sessionId, locale, userHasSigned, disabled }) {
  const [t] = useTranslation()
  const [postContract] = useLazyRequest(signSessionContract)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const user = useUser()
  useErrorHandlerOverlay(error)

  const onClick = async () => {
    setLoading(true)
    try {
      const body = { sessionId, locale, cisId: user.cisId }
      const data = await postContract(body)
      const url = new URL(data.headers.location)
      const path = `/rootstech/contracts/presenter-agreement${url.search}`
      // we need to use location.assign in order to leave the app and route via the blueprint
      window.location.assign(path)
      // NOTE: don't update the loading state because we want to keep the button disabled while the browser is loading the page
    } catch (e) {
      setError(e)
      setLoading(false)
    }
  }

  return (
    <PillButton
      emphasis="medium"
      linkName="Sign Contract"
      data-testid="button-sign-contract"
      onClick={onClick}
      disabled={loading || disabled || userHasSigned}
      Icon={loading ? NoticeLoading : undefined}
    >
      {userHasSigned ? t('dashboard.signed-contract', 'Signed') : t('dashboard.sign-contract', 'Sign Contract')}
    </PillButton>
  )
}
